module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"engineeringEstimationError":"There was an error generating menu engineering profitability estimation"},"es":{"engineeringEstimationError":"Hubo un error generando la estimación de rentabilidad de menu engineering"}}')
  delete Component.options._Ctor
}
